import { StatusFilter } from 'assets/js/pages/engage/types';
import { StateCreator } from 'zustand';

interface EngageMessagesState {
    messageIndexTab: StatusFilter;
    setMessageIndexTab: (tab: StatusFilter) => void;
    hasDismissedVisualEditorCallout: boolean;
    setHasDismissedVisualEditorCallout: (hasDismissed: boolean) => void;
}

const createEngageMessagesSlice: StateCreator<
    any,
    [['zustand/persist', unknown]],
    [],
    EngageMessagesState
> = set => ({
    messageIndexTab: 'sent',
    setMessageIndexTab: messageIndexTab =>
        set({
            messageIndexTab,
        }),
    hasDismissedVisualEditorCallout: false,
    setHasDismissedVisualEditorCallout: hasDismissedVisualEditorCallout =>
        set({ hasDismissedVisualEditorCallout }),
});

export { createEngageMessagesSlice };
export type { EngageMessagesState };
